<template>
	<div
		ref="screen"
		class="columns is-multiline mt-0"
		style="position: relative">
		<b-loading
			:is-full-page="falsehood"
			v-model="isSearching"
			:can-cancel="true"></b-loading>
		<div class="column is-full has-text-centered mt-2 mb-2 is-size-6">
			<p
				v-if="
					this.$store.getters.products.length ||
					this.$store.getters.shops.length
				"
				class="mb-0">
				Results:
				{{
					this.$store.getters.products.length +
					this.$store.getters.shops.length
				}}
				(Products: {{ this.$store.getters.products.length }}, Shops:
				{{ this.$store.getters.shops.length }})
			</p>
			<p
				v-else-if="this.isSearching"
				class="mb-0">
				Searching...
			</p>
			<p
				v-else
				class="mb-0">
				No Results
			</p>
		</div>
		<div
			v-if="shops.length > 0 && tab == 'overview'"
			class="column is-full has-background-info-light pb-4"
			style="max-width: 100%; width: 1800px; margin: auto">
			<p
				class="is-size-4 has-text-grey has-text-weight-bold has-text-centered mb-0 has-font-family-nunito">
				Relevant Shops
			</p>
			<div
				class="columns is-mobile is-multiline mwidth-full margin-auto is-centered is-vcentered">
				<div
					v-if="layout == 'normal-card'"
					v-for="(shop, index) in overviewShops"
					class="column is-2-desktop is-3-tablet is-half-mobile"
					style="align-items: stretch; display: flex">
					<div
						class="card width-full has-background-white-ter"
						style="align-items: stretch">
						<div class="card-image">
							<a :href="shop.link">
								<figure class="product-image image is-4by5">
									<img
										:src="shop.images[0]"
										:key="shop.name + shop.id + 'image'"
										:alt="shop.name" />
								</figure>
							</a>
						</div>
						<div
							class="card-content pl-2 pr-2 pt-0 pb-0 m-0 has-text-centered">
							<p
								class="is-size-6 mt-1 ml-0 mr-0 mb-0 p-0 has-font-family-sans"
								style="
									text-overflow: ellipsis;
									overflow: hidden;
									white-space: nowrap;
								">
								<span class="">{{ shop.name }}</span>
							</p>
							<p class="mb-1">
								<a
									:href="shop.link"
									class="has-text-info is-size-6 has-font-family-sans"
									>{{ "@" + shop.slug }}</a
								>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="column is-full">
			<div class="columns pt-4 pl-4 pr-4 is-vcentered">
				<div
					v-show="tab == 'overview' || tab == 'products'"
					class="column">
					<div class="columns is-vcentered">
						<div class="comming-soon column is-narrow">
							<div class="field has-addons">
								<div class="control">
									<div
										class="select is-small"
										@change="applyProductFilter">
										<select ref="category">
											<option
												value=""
												selected>
												Category
											</option>
											<option value="Argentina">Argentina</option>
											<option value="Bolivia">Bolivia</option>
											<option value="Brazil">Brazil</option>
											<option value="Chile">Chile</option>
											<option value="Colombia">Colombia</option>
											<option value="Ecuador">Ecuador</option>
											<option value="Guyana">Guyana</option>
											<option value="Paraguay">Paraguay</option>
											<option value="Peru">Peru</option>
											<option value="Suriname">Suriname</option>
											<option value="Uruguay">Uruguay</option>
											<option value="Venezuela">Venezuela</option>
										</select>
									</div>
								</div>
								<div class="control">
									<div class="select is-small">
										<select
											ref="subCategory"
											@change="applyProductFilter">
											<option
												value=""
												selected>
												Sub-Category
											</option>
											<option value="Argentina">Argentina</option>
											<option value="Bolivia">Bolivia</option>
											<option value="Brazil">Brazil</option>
											<option value="Chile">Chile</option>
											<option value="Colombia">Colombia</option>
											<option value="Ecuador">Ecuador</option>
											<option value="Guyana">Guyana</option>
											<option value="Paraguay">Paraguay</option>
											<option value="Peru">Peru</option>
											<option value="Suriname">Suriname</option>
											<option value="Uruguay">Uruguay</option>
											<option value="Venezuela">Venezuela</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div class="column is-narrow">
							<div class="control">
								<div class="select is-small">
									<select
										ref="paymentModel"
										@change="applyProductFilter">
										<option
											value=""
											selected>
											All Payment Models
										</option>
										<option value="Single-Payment">
											Single-Payment
										</option>
										<option value="Subscription">Subscription</option>
										<option value="Auction">Auction</option>
										<option value="Negotiate">Negotiate</option>
									</select>
								</div>
							</div>
						</div>
						<div class="column is-narrow">
							<div class="field has-addons">
								<div class="control">
									<div
										class="select is-small"
										@change="applyProductFilter">
										<select ref="currency">
											<option
												value=""
												selected>
												All Currencies
											</option>
											<option
												value="JMD"
												selected>
												JMD
											</option>
											<option value="USD">USD</option>
										</select>
									</div>
								</div>
								<div class="control">
									<input
										ref="minPrice"
										@change="applyProductFilter"
										type="number"
										class="input is-small"
										placeholder="Min Price"
										name="min" />
								</div>
								<div class="control">
									<input
										ref="maxPrice"
										@change="applyProductFilter"
										type="number"
										class="input is-small"
										placeholder="Max Price"
										name="max" />
								</div>
							</div>
						</div>
						<div class="column is-narrow">
							<span
								class="is-size-6 m-0"
								v-if="filteredProducts.length != products.length"
								v-html="
									'Filtered Results: ' + filteredProducts.length
								"></span>
						</div>
						<div class="column is-narrow">
							<button
								ref="clearFiltersButton"
								class="button is-small is-light"
								@click="clearFilters">
								Clear Filters
							</button>
						</div>
					</div>
				</div>
				<div class="comming-soon is-narrow column has-text-right">
					<button
						@click="setLayout('normal-card')"
						class="button is-white">
						<i class="fas fa-th"></i>
					</button>
					<button
						@click="setLayout('large-card')"
						class="button is-white">
						<i class="fas fa-th-large"></i>
					</button>
					<button
						@click="setLayout('normal-list')"
						class="button is-white">
						<i class="fas fa-list"></i>
					</button>
					<button
						@click="setLayout('large-list')"
						class="button is-white">
						<i class="fas fa-th-list"></i>
					</button>
				</div>
			</div>
		</div>
		<!-- Overview Start -->
		<div
			v-if="tab == 'overview'"
			class="column is-full">
			<div class="columns is-multiline">
				<div
					class="column is-full"
					key="lister">
					<!-- Listers Start -->
					<!-- Normal Card Start -->
					<div
						class="columns is-mobile is-multiline mwidth-full margin-auto">
						<div
							v-if="layout == 'normal-card'"
							v-for="(product, index) in filteredProducts"
							class="column px-1-mobile is-one-fifth-desktop is-one-third-tablet is-half-mobile"
							style="align-items: stretch; display: flex">
							<!--  -->
							<div class="card width-100">
								<div class="card-image">
									<figure class="image is-square">
										<a :href="product.link">
											<picture>
												<source
													v-for="srcset in srcsetImagePath(
														product.images[0]
													)"
													:srcset="srcset.path"
													:media="srcset.media"
													:type="srcset.type" />
												<!-- prettier-ignore -->
												<img :src="isSearching ? '' : product.images[0]" :key="product.name + product.id + 'image'" :alt="product.name" style="object-fit: cover" />
											</picture>
										</a>
									</figure>
								</div>
								<div class="card-content pt-2 pb-2 pl-3 pr-3">
									<div class="content has-text-centered">
										<p class="is-size-7 mb-0">
											<a :href="product.shop_link"
												>&#64;{{ product.shop }}</a
											>
										</p>
										<p
											class="is-size-6 mt-3 mb-0"
											style="
												text-overflow: ellipsis;
												overflow: hidden;
												white-space: nowrap;
											">
											<a :href="product.link">{{ product.name }}</a>
										</p>
										<p class="mt-2 has-text-weight-bold">
											<span class="is-block is-size-6">{{ product.display_price }} {{ product.display_currency }}</span>
											<span
												class="tag is-light is-size-6 mt-4 mb-1 has-text-weight-normal"
												style="border: none">
												<span class="is-size-6">
													{{ pricingModelEmoji(product.model) }}
												</span>
												<span class="is-size-7">
													{{ "&nbsp;" + product.model }}
												</span>
											</span>
										</p>
									</div>
								</div>
							</div>
							<!--  -->
						</div>
					</div>
					<!-- Normal Card End -->
					<!-- Large Card Start -->
					<div
						class="columns is-mobile is-multiline mwidth-full margin-auto">
						<div
							v-if="layout == 'large-card'"
							v-for="(product, index) in filteredProducts"
							class="column px-1-mobile is-3-desktop is-one-third-tablet is-half-mobile"
							style="align-items: stretch; display: flex">
							<!--  -->
							<div class="card width-100">
								<div class="card-image">
									<figure class="image is-square">
										<a :href="product.link">
											<picture>
												<source
													v-for="srcset in srcsetImagePath(
														product.images[0]
													)"
													:srcset="srcset.path"
													:media="srcset.media"
													:type="srcset.type" />
												<!-- prettier-ignore -->
												<img :src="isSearching ? '' : product.images[0]" :key="product.name + product.id + 'image'" :alt="product.name" style="object-fit: cover" />
											</picture>
										</a>
									</figure>
								</div>
								<div class="card-content pt-2 pb-2 pl-3 pr-3">
									<div class="content has-text-centered">
										<p class="is-size-7 mb-0">
											<a :href="product.shop_link"
												>&#64;{{ product.shop }}</a
											>
										</p>
										<p
											class="is-size-6 mt-3 mb-0"
											style="
												text-overflow: ellipsis;
												overflow: hidden;
												white-space: nowrap;
											">
											<a :href="product.link">{{ product.name }}</a>
										</p>
										<p class="mt-2 has-text-weight-bold">
											<span class="is-block is-size-6">{{ product.display_price }} {{ product.display_currency }}</span>
											<span
												class="tag is-light is-size-6 mt-4 mb-1 has-text-weight-normal"
												style="border: none">
												<span class="is-size-6">
													{{ pricingModelEmoji(product.model) }}
												</span>
												<span class="is-size-7">
													{{ "&nbsp;" + product.model }}
												</span>
											</span>
										</p>
									</div>
								</div>
							</div>
							<!--  -->
						</div>
					</div>
					<!-- Large Card End -->
					<!-- Listers End -->
				</div>
			</div>
		</div>
		<!-- Overview Stop -->
		<!-- Products Start -->
		<div
			v-if="tab == 'products'"
			class="column is-full">
			<div class="columns is-multiline">
				<div
					class="column is-full"
					key="lister">
					<!-- Listers Start -->
					<!-- Normal Card Start -->
					<div
						class="columns is-mobile is-multiline mwidth-full margin-auto">
						<div
							v-if="layout == 'normal-card'"
							v-for="(product, index) in filteredProducts"
							class="column px-1-mobile is-one-fifth-desktop is-one-third-tablet is-half-mobile"
							style="align-items: stretch; display: flex">
							<!--  -->
							<div class="card width-100">
								<div class="card-image">
									<figure class="image is-square">
										<a :href="product.link">
											<picture>
												<source
													v-for="srcset in srcsetImagePath(
														product.images[0]
													)"
													:srcset="srcset.path"
													:media="srcset.media"
													:type="srcset.type" />
												<!-- prettier-ignore -->
												<img :src="isSearching ? '' : product.images[0]" :key="product.name + product.id + 'image'" :alt="product.name" style="object-fit: cover" />
											</picture>
										</a>
									</figure>
								</div>
								<div class="card-content pt-2 pb-2 pl-3 pr-3">
									<div class="content has-text-centered">
										<p class="is-size-7 mb-0">
											<a :href="product.shop_link"
												>&#64;{{ product.shop }}</a
											>
										</p>
										<p
											class="is-size-6 mt-3 mb-0"
											style="
												text-overflow: ellipsis;
												overflow: hidden;
												white-space: nowrap;
											">
											<a :href="product.link">{{ product.name }}</a>
										</p>
										<p class="mt-2 has-text-weight-bold">
											<span class="is-block is-size-6">{{ product.display_price }} {{ product.display_currency }}</span>
											<span
												class="tag is-light is-size-6 mt-4 mb-1 has-text-weight-normal"
												style="border: none">
												<span class="is-size-6">
													{{ pricingModelEmoji(product.model) }}
												</span>
												<span class="is-size-7">
													{{ "&nbsp;" + product.model }}
												</span>
											</span>
										</p>
									</div>
								</div>
							</div>
							<!--  -->
						</div>
					</div>
					<!-- Normal Card End -->
					<!-- Large Card Start -->
					<div
						class="columns is-mobile is-multiline mwidth-full margin-auto">
						<div
							v-if="layout == 'large-card'"
							v-for="(product, index) in filteredProducts"
							class="column px-1-mobile is-3-desktop is-one-third-tablet is-half-mobile"
							style="align-items: stretch; display: flex">
							<!--  -->
							<div class="card width-100">
								<div class="card-image">
									<figure class="image is-square">
										<a :href="product.link">
											<picture>
												<source
													v-for="srcset in srcsetImagePath(
														product.images[0]
													)"
													:srcset="srcset.path"
													:media="srcset.media"
													:type="srcset.type" />
												<!-- prettier-ignore -->
												<img :src="isSearching ? '' : product.images[0]" :key="product.name + product.id + 'image'" :alt="product.name" style="object-fit: cover" />
											</picture>
										</a>
									</figure>
								</div>
								<div class="card-content pt-2 pb-2 pl-3 pr-3">
									<div class="content has-text-centered">
										<p class="is-size-7 mb-0">
											<a :href="product.shop_link"
												>&#64;{{ product.shop }}</a
											>
										</p>
										<p
											class="is-size-6 mt-3 mb-0"
											style="
												text-overflow: ellipsis;
												overflow: hidden;
												white-space: nowrap;
											">
											<a :href="product.link">{{ product.name }}</a>
										</p>
										<p class="mt-2 has-text-weight-bold">
											<span class="is-block is-size-6">{{ product.display_price }} {{ product.display_currency }}</span>
											<span
												class="tag is-light is-size-6 mt-4 mb-1 has-text-weight-normal"
												style="border: none">
												<span class="is-size-6">
													{{ pricingModelEmoji(product.model) }}
												</span>
												<span class="is-size-7">
													{{ "&nbsp;" + product.model }}
												</span>
											</span>
										</p>
									</div>
								</div>
							</div>
							<!--  -->
						</div>
					</div>
					<!-- Large Card End -->
					<!-- Listers End -->
				</div>
			</div>
		</div>
		<!-- Products Stop -->
		<!-- Shops Start -->
		<div
			v-if="tab == 'shops'"
			class="column is-full">
			<div class="columns is-multiline">
				<div
					class="column is-full"
					key="lister">
					<!-- Listers Start -->
					<!-- Normal Card Start -->
					<div
						class="columns is-mobile is-multiline mwidth-full margin-auto">
						<div
							v-if="layout == 'normal-card'"
							v-for="(shop, index) in computedShops"
							class="column product-column is-one-fifth-desktop is-one-third-tablet is-half-mobile"
							style="align-items: stretch; display: flex">
							<!--  -->
							<div
								class="card width-full has-background-white-ter"
								style="align-items: stretch">
								<div class="card-image">
									<a :href="shop.link">
										<figure class="product-image image is-4by5">
											<img
												:src="shop.images[0]"
												:key="shop.name + shop.id + 'image'"
												:alt="shop.name" />
										</figure>
									</a>
								</div>
								<div
									class="card-content pl-2 pr-2 pt-0 pb-0 m-0 has-text-centered">
									<p
										class="is-size-6 mt-1 ml-0 mr-0 mb-0 p-0 has-font-family-sans"
										style="
											text-overflow: ellipsis;
											overflow: hidden;
											white-space: nowrap;
										">
										<span class="">{{ shop.name }}</span>
									</p>
									<p class="mb-1">
										<a
											:href="shop.link"
											class="has-text-info is-size-6 has-font-family-sans"
											>{{ "@" + shop.slug }}</a
										>
									</p>
								</div>
							</div>
							<!--  -->
						</div>
					</div>
					<!-- Normal Card End -->
					<!-- Large Card Start -->
					<div
						class="columns is-mobile is-multiline mwidth-full margin-auto">
						<div
							v-if="layout == 'large-card'"
							v-for="(shop, index) in computedShops"
							class="column product-column is-3-desktop is-one-third-tablet is-half-mobile"
							style="align-items: stretch; display: flex">
							<div class="product-wrap width-full">
								<div class="product">
									<figure
										class="image is-4by5"
										style="border: solid 1px #F0F0F0; border-radius 2px;">
										<a :href="shop.link">
											<img
												:src="shop.images[0]"
												:key="shop.name + shop.id + 'image'"
												:alt="shop.name"
												width="280"
												height="315" />
										</a>
									</figure>
									<div class="product-details">
										<div
											class="product-cat has-text-transform-none is-size-5">
											<a :href="shop.link">{{ "@" + shop.slug }}</a>
										</div>
										<h3 class="product-name">
											<a :href="shop.link">{{ shop.name }}</a>
										</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Large Card End -->
					<!-- Listers End -->
				</div>
			</div>
		</div>
		<!-- Shops Stop -->
		<div class="column is-full has-text-centered">
			<button
				v-if="!disableLoadMoreButton"
				@click="paginate"
				:disabled="disableLoadMoreButton"
				class="button is-size-5 is-info has-text-weight-bold"
				:class="{ 'is-loading': isSearching }"
				style="min-width: 40%">
				Load More Results
			</button>
			<p
				v-else
				class="is-size-4 is-white">
				<span v-html="resultsMessage"></span><br /><i class="is-size-5"
					><span v-show="someItemsAreFiltered"
						>( Click 'Clear Filter' above to see all results )</span
					></i
				>
			</p>
		</div>
	</div>
</template>
<style type="text/css" scoped>
	.comming-soon {
		display: none;
	}
	.width-100 {
		width: 100%;
	}
	.has-text-transform-none {
		text-transform: none !important;
	}
</style>
<script type="text/javascript">
	import axios from "axios";
	axios.defaults.headers.post["X-CSRF-TOKEN"] = window.csrf_token;

	export default {
		props: ["search_link"],
		mounted() {
			this.mounted = true;
		},
		data() {
			return {
				layout: "normal-card",
				state: this.$store.state,
				products: [],
				shops: [],
				mounted: false,
				tab: this.$store.getters.marketTab,
				filteredProducts: [],
				isSearching: false,
				truth: true,
				falsehood: false,
				loadingComponent: null,
				imageVariants: [
					{ size: "xxs", media: "(min-width: 250px)", encoding: "webp" },
				],
			};
		},
		computed: {
			overviewShops() {
				let s = [];
				for (
					let counter = 0,
						count = this.shops.length >= 5 ? 5 : this.shops.length;
					counter < count;
					counter++
				) {
					s[counter] = this.shops[counter];
				}
				return s;
			},
			computedShops() {
				return this.shops;
			},
			disableLoadMoreButton() {
				if (
					(this.tab == "overview" || this.tab == "products") &&
					this.$store.getters.productsCurrentPage >=
						this.$store.getters.productsTotalPages
				) {
					return true;
				}
				if (
					this.tab == "shops" &&
					this.$store.getters.productsCurrentPage >=
						this.$store.getters.shopsTotalPages
				) {
					return true;
				}
				return false;
			},
			someItemsAreFiltered() {
				if (
					(this.tab == "overview" || this.tab == "products") &&
					this.filteredProducts.length == this.products.length
				) {
					return false;
				} else if (
					this.tab == "shops" &&
					this.shops.length == this.computedShops.length
				) {
					return false;
				}
				return true;
			},
			resultsMessage() {
				if (this.isSearching) {
					return "Searching...";
				} else if (
					(this.tab == "overview" || this.tab == "products") &&
					this.products.length == 0 &&
					this.products.length == this.filteredProducts.length
				) {
					return "No Results";
				} else if (
					this.tab == "shops" &&
					this.shops.length == 0 &&
					this.shops.length == this.computedShops.length
				) {
					return "No Results";
				}
				return "No More Results";
			},
		},
		methods: {
			setLayout(value) {
				this.layout = value;
			},
			price: function (obj) {
				let t = this;
				if (obj.current > 0) {
					return `${obj.current.toLocaleString("en-US", {
						style: "currency",
						currency: "USD", // if currency other than USD is used currency will be printed
					})} ${obj.currency}`;
				} else if (obj.current == 0) {
					return "FREE";
				} else if (obj.current == -1 || obj.current < 0) {
					return "NEGOTIABLE";
				}
			},
			currency_symbol(obj) {
				if (obj.currency == "JMD" || obj.currency == "USD") {
					return "$";
				}
			},
			applyProductFilter() {
				if (
					!this.$refs.hasOwnProperty("paymentModel") ||
					!this.$refs.hasOwnProperty("currency") ||
					!this.$refs.hasOwnProperty("minPrice") ||
					!this.$refs.hasOwnProperty("maxPrice")
				) {
					console.error(
						"A filter property is missing, cannot properly filter"
					);
					return;
				}
				this.filteredProducts = this.computedProducts();
			},
			clearFilters() {
				this.$refs.clearFiltersButton.classList.add("is-loading");
				this.$refs.paymentModel.value = "";
				this.$refs.currency.value = "";
				this.$refs.minPrice.value = "";
				this.$refs.maxPrice.value = "";
				this.filteredProducts = this.products;
				this.$refs.clearFiltersButton.classList.remove("is-loading");
			},
			computedProducts() {
				let _this = this;
				if (
					!this
						.mounted /*|| (this.tab !== 'overview' && this.tab !== 'products')*/
				) {
					return [];
				}
				let p = this.products;
				if (this.$refs.paymentModel.value) {
					p = p.filter(function (element) {
						return (
							element.pricing.model == _this.$refs.paymentModel.value
						);
					});
				}
				if (this.$refs.currency.value) {
					p = p.filter(function (element) {
						return element.pricing.currency == _this.$refs.currency.value;
					});
				}
				if (this.$refs.minPrice.value) {
					p = p.filter(function (element) {
						return (
							element.pricing.current >=
							parseFloat(_this.$refs.minPrice.value)
						);
					});
				}
				if (this.$refs.maxPrice.value) {
					p = p.filter(function (element) {
						return (
							element.pricing.current <=
							parseFloat(_this.$refs.maxPrice.value)
						);
					});
				}
				return p;
			},
			pricingModelEmoji(pricing_model) {
				switch (pricing_model) {
					case "Single-Payment":
						return "💵";
					case "Subscription":
						return "🎟";
					case "Negotiate":
						return "🤝";
					case "Auction":
						return "👨🏽‍⚖️";
				}
				return "";
			},
			productsPaginatePromise() {
				let _this = this;
				let url = this.search_link;
				let currentPage = this.$store.getters.productsCurrentPage;
				let totalPages = this.$store.getters.productsTotalPages;
				let page = currentPage < totalPages ? currentPage + 1 : currentPage;
				return axios.post(url, {
					type: "products",
					page: page,
					query: _this.searchTerm(),
				});
			},
			shopsPaginatePromise() {
				let _this = this;
				let url = this.search_link;
				let currentPage = this.$store.getters.shopsCurrentPage;
				let totalPages = this.$store.getters.shopsTotalPages;
				let page = currentPage < totalPages ? currentPage + 1 : currentPage;
				return axios.post(url, {
					type: "shops",
					page: page,
					query: _this.searchTerm(),
				});
			},
			paginate() {
				let _this = this;
				_this.$store.dispatch("set_is_searching", true);

				if (this.tab == "overview" || this.tab == "products") {
					_this
						.productsPaginatePromise()
						.then(function (response) {
							_this.$store.dispatch("set_products", response.data);
							_this.products = _this.$store.getters.products;
							_this.applyProductFilter();
						})
						.catch(function (error) {})
						.then(function (response) {
							_this.$store.dispatch("set_is_searching", false);
							// Calling the value below to update the responsiveness of the 'Load More' button
							_this.disableLoadMoreButton;
						});
				} else if (this.tab == "shops") {
					_this
						.shopsPaginatePromise()
						.then(function (response) {
							_this.$store.dispatch("set_shops", response.data);
							_this.shops = _this.$store.getters.shops;
						})
						.catch(function (error) {})
						.then(function (response) {
							_this.$store.dispatch("set_is_searching", false);
							// Calling the value below to update the responsiveness of the 'Load More' button
							_this.disableLoadMoreButton;
						});
				}
			},
			searchTerm() {
				return this.$store.getters.searchTerm;
			},
			srcsetImagePath(originalImagePath) {
				let srcsetArray = this.imageVariants.map((variant) => {
					let pattern = `(.${"jpg"}$)`;
					variant.path = originalImagePath
						.replace(
							new RegExp(pattern),
							`-${variant.size}.${variant.encoding}`
						)
						.replace(new RegExp(/ /g), "%20"); // Replace spaces in path with %20
					variant.type = `image/${variant.encoding}`;
					return variant;
				});
				console.log(srcsetArray);
				return srcsetArray;
			},
		},
		watch: {
			state: {
				deep: true,
				handler(newValue, oldValue) {
					this.products = this.$store.getters.products;
					this.shops = this.$store.getters.shops;
					this.tab = this.$store.getters.marketTab;
					this.isSearching = this.$store.getters.marketIsSearching;
					this.applyProductFilter();
				},
			},
			tab: {
				handler(newValue, oldValue) {
					this.applyProductFilter();
				},
			},
		},
	};
</script>
